<template>
  <div class="_body">
    <Header />
    <div class="_page">
      <div class="_content">
        <qyjbxx-1 :dwhcpd="dwhcpd" />
      </div>
    </div>
  </div>
</template>

<script>
// 获取接口地址
import Qyjbxx1 from '@/components/qyjbxx/qyjbxx1'
export default {
  name: 'Qyjbxx',
  components: {
    // sideMenu,
    // Header,
    Qyjbxx1
  },
  data() {
    return {
      dwhcpd: true
    }
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
